/**
 * components/Dot
 * The 6–7px status dot that precedes a KPI label or a chart legend row. It
 * carries the tone's `dot` colour, which is the one saturated value in each
 * status family — the fills and borders are all pale.
 */
import { View } from 'react-native';
import { radii } from '../../theme/radii';
import { toneOf, type ToneName } from '../../lib/status';

export interface DotProps {
  tone?: ToneName;
  /** An explicit colour, for the chart series which are not status tones. */
  color?: string;
  /** 6px in chip rows and legends, 7px on a KPI card. */
  size?: number;
}

export function Dot({ tone, color, size = 6 }: DotProps) {
  return (
    <View
      style={{
        width: size,
        height: size,
        borderRadius: radii.pill,
        backgroundColor: color ?? (tone ? toneOf(tone).dot : undefined),
        flexShrink: 0,
      }}
    />
  );
}

export default Dot;
